import styled from 'styled-components';
import { Text, FlexRow } from '@make-software/tg-mini-app-ui';

export const NoFriendsWrapper = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    height: '100%',
    flexDirection: 'column',
    padding: '0 16px',
    position: 'relative'
  })
);

export const Banner = styled.img(({ theme }) =>
  theme.withMedia({
    height: '200px',
    width: '200px',
    marginBottom: '40px'
  })
);

export const Content = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    textAlign: 'center'
  })
);

export const Title = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontWeight: '700',
    fontFamily: 'Inter'
  })
);

export const SubTitle = styled.span(({ theme }) =>
  theme.withMedia({
    fontSize: '12px',
    fontWeight: '400',
    color: theme.colors.contentOnFill,
    fontFamily: 'Inter'
  })
);

export const ButtonWrapper = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    width: '94%',
    position: 'absolute',
    bottom: '14px'
  })
);
